/**
 * Shipping & Delivery Page
 *
 * Task: T4.3.4 - Policy pages
 */

import {
  Page,
  Layout,
  Card,
  Text,
  BlockStack,
  Box,
  DataTable,
} from '@shopify/polaris';

export function ShippingPage() {
  const deliveryTimelines = [
    ['Metro Cities', 'Standard: 7-10 days', 'Express: 3-5 days'],
    ['Tier 2 Cities', 'Standard: 10-12 days', 'Express: 5-7 days'],
    ['Other Locations', 'Standard: 12-15 days', 'Express: 7-10 days'],
    ['Remote Areas', 'Standard: 15-20 days', 'Not available'],
  ];

  return (
    <Page title="Shipping & Delivery" narrowWidth>
      <Layout>
        <Layout.Section>
          <Card>
            <Box padding="600">
              <BlockStack gap="600">
                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Delivery Coverage
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We deliver across India to all major cities, towns, and most remote locations.
                    Our logistics partners include reputed courier services ensuring safe and
                    timely delivery of your orders.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Delivery Timelines
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Delivery timelines are calculated from the date of dispatch, which typically
                    occurs after production completion and quality check.
                  </Text>
                  <DataTable
                    columnContentTypes={['text', 'text', 'text']}
                    headings={['Location', 'Standard Delivery', 'Express Delivery']}
                    rows={deliveryTimelines}
                  />
                  <Text as="p" variant="bodySm" tone="subdued">
                    * Production time (typically 5-7 business days) is additional for customized orders.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Shipping Charges
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Shipping charges are calculated based on:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Order weight and dimensions
                    <br />
                    • Delivery location
                    <br />
                    • Shipping method selected (Standard/Express)
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Free shipping is available for orders above ₹25,000 to select metro cities.
                    Exact shipping charges will be displayed at checkout or included in your quote.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Order Tracking
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Once your order is dispatched, you will receive:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Email notification with tracking details
                    <br />
                    • SMS notification with tracking link
                    <br />
                    • Real-time tracking through our order status page
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Delivery Instructions
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Please ensure someone is available to receive the delivery
                    <br />
                    • For large orders, ensure adequate space for unloading
                    <br />
                    • Inspect packages before signing for receipt
                    <br />
                    • Report any visible damage immediately to the delivery person
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Multiple Delivery Addresses
                  </Text>
                  <Text as="p" variant="bodyMd">
                    We can deliver to multiple addresses for a single order. This is useful for:
                  </Text>
                  <Text as="p" variant="bodyMd">
                    • Employee gifting programs
                    <br />
                    • Client appreciation campaigns
                    <br />
                    • Event distributions
                  </Text>
                  <Text as="p" variant="bodyMd">
                    Additional handling charges may apply for multiple-address deliveries.
                    Please contact us for a customized quote.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    International Shipping
                  </Text>
                  <Text as="p" variant="bodyMd">
                    International shipping is available on request. Please contact our sales
                    team for quotes and customs/import duty information.
                  </Text>
                </BlockStack>

                <BlockStack gap="400">
                  <Text as="h2" variant="headingMd">
                    Contact Us
                  </Text>
                  <Text as="p" variant="bodyMd">
                    For shipping-related queries, contact us at:
                    <br />
                    Email: shipping@corporategifts.com
                    <br />
                    Phone: +91 98765 43210
                  </Text>
                </BlockStack>
              </BlockStack>
            </Box>
          </Card>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
